import { Stack } from "@mui/material";
import SectionDivider from "../../../../../components/misc/SectionDivider";
import {
  DateTimeSelection,
  GameTypeSelection,
  LocationSelection,
  PaymentCollection,
  PlayerDetails,
} from "./parts";

const GameStep = ({
  gameData,
  onGameInputChange,
  onGameTypeChange,
  onSportChange,
  onGameDataChange,
  onLocationSelect,
  onAddressChange,
  onVenueChange,
  onPlayerAmountChange,
  onRevolutToggle,
  onRevolutLinkChange,
  paymentReadOnly = false,
}) => {
  return (
    <Stack spacing={4}>
      {/* Game Type Selection */}
      <GameTypeSelection
        gameData={gameData}
        onGameTypeChange={onGameTypeChange}
        onSportChange={onSportChange}
      />

      <SectionDivider />

      {/* Date and Time Selection */}
      <DateTimeSelection
        gameData={gameData}
        onGameInputChange={onGameInputChange}
        onGameDataChange={onGameDataChange}
      />

      <SectionDivider />

      {/* Location Selection with Google Maps */}
      <LocationSelection
        gameData={gameData}
        onLocationSelect={onLocationSelect}
        onAddressChange={onAddressChange}
        onVenueChange={onVenueChange}
        onHowToFindUsChange={onGameInputChange("how_to_find")}
      />

      <SectionDivider />

      {/* Player Details */}
      <PlayerDetails
        gameData={gameData}
        onGameInputChange={onGameInputChange}
      />

      {/* Payment Collection */}
      <SectionDivider />

      <PaymentCollection
        gameData={gameData}
        onPlayerAmountChange={onPlayerAmountChange}
        onRevolutToggle={onRevolutToggle}
        onRevolutLinkChange={onRevolutLinkChange}
        onGameDataChange={onGameDataChange}
        readOnly={paymentReadOnly}
      />
    </Stack>
  );
};

export default GameStep;
